"use client";

import useProductDetail from "@/app/lib/features/productDetail/productDetail.hook";
import useModal from "@/app/lib/features/modal/modal.hook";
import FallbackImage from "@/app/components/elements/FallbackImage";
import { trackInteraction } from "@/app/lib/tracking/interactions";

const CollectionButton = () => {
  const { product } = useProductDetail();
  const { createModal } = useModal();

  if (!product?.collection_info) return null;

  const { icon, icon_2, button_text, button_background, button_text_color } =
    product.collection_info;

  const handleClick = () => {
    trackInteraction("product", product.id, "click");
    createModal("add-to-collection", {
      variantId: product.variant_id,
      productId: product.id,
      productName: product.internet_product_description || product.name,
      productImage: product.first_image || product.images?.[0],
    });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="cursor-pointer bg-white w-full border p-2 rounded-md flex items-center gap-2 font-medium text-xs transition-all duration-300 ease-in-out hover:border-black hover:shadow-lg"
      style={{
        backgroundColor: button_background,
        color: button_text_color,
      }}
    >
      <div className="w-8 h-8 flex items-center justify-center bg-[#f5f5f5] rounded-md shrink-0 relative overflow-hidden">
        <FallbackImage
          src={icon}
          alt="Collection"
          fill
          className="object-contain p-1"
          fallbackClassName="object-contain p-1 opacity-60"
        />
      </div>
      <p className="flex-1">{button_text}</p>
      <div className="w-5 h-5 flex items-center justify-center shrink-0 relative">
        <FallbackImage
          src={icon_2}
          alt="Add to Collection"
          fill
          className="object-contain"
          fallbackClassName="object-contain opacity-60"
        />
      </div>
    </button>
  );
};

export default CollectionButton;